import { exists } from './exists'

/**
 * 検査対象が存在するかどうかをチェックし、存在する場合は変換関数を適用した結果を返し、存在しない場合は null を返します。
 *
 * @template T - 検査対象の型。
 * @template U - 変換後の型。
 * @param value - 検査対象。
 * @param converter - 変換関数。
 * @returns 変換後の値。
 */
export function toContentOrNull<T, U>(
  value: T | null | undefined,
  converter: (value: T) => U,
): U | null {
  if (!exists(value)) {
    return null
  }

  return converter(value)
}
